import { useEffect, useState } from "react";
import { MonitorSmartphone, Share, PlusSquare } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

let istem = null;
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); istem = e; });

const basaEkle = (tag, attrs) => {
  if (document.head.querySelector(`${tag}[data-bayi="${attrs.rel || attrs.name}"]`)) return;
  const el = document.createElement(tag);
  Object.entries({ ...attrs, "data-bayi": attrs.rel || attrs.name }).forEach(([k, v]) => el.setAttribute(k, v));
  document.head.appendChild(el);
};

const kurulu = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
const ios = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const KisayolEkle = () => {
  const [acik, setAcik] = useState(false);
  const [gizle, setGizle] = useState(kurulu());
  useEffect(() => {
    basaEkle("link", { rel: "manifest", href: "/bayi-manifest.json" });
    basaEkle("link", { rel: "apple-touch-icon", href: "/bayi-ikon-192.png" });
    basaEkle("meta", { name: "theme-color", content: "#1E3A8A" });
    basaEkle("meta", { name: "apple-mobile-web-app-capable", content: "yes" });
    if ("serviceWorker" in navigator) { navigator.serviceWorker.register("/sw.js").catch(() => {}); }
    const k = () => setGizle(true);
    window.addEventListener("appinstalled", k);
    return () => window.removeEventListener("appinstalled", k);
  }, []);
  if (gizle) return null;
  const tikla = async () => {
    if (istem) { istem.prompt(); const r = await istem.userChoice; istem = null; if (r.outcome === "accepted") setGizle(true); return; }
    setAcik(true);
  };
  return (
    <>
      <button onClick={tikla} data-testid="bayi-kisayol" title="Masaüstüne / ana ekrana kısayol ekle"
        className="inline-flex items-center gap-2 h-9 px-3 rounded-full text-xs border border-white/15 hover:bg-white/10 transition-colors">
        <MonitorSmartphone className="w-4 h-4" /><span className="hidden sm:inline">Kısayol ekle</span></button>
      <Dialog open={acik} onOpenChange={setAcik}>
        <DialogContent className="glass max-w-md" data-testid="bayi-kisayol-dialog">
          <DialogHeader><DialogTitle>Bayi portalını kısayol olarak ekleyin</DialogTitle>
            <DialogDescription>Kısayol eklendiğinde portal tek dokunuşla, uygulama gibi açılır.</DialogDescription></DialogHeader>
          {ios() ? (
            <ol className="space-y-3 text-sm list-decimal ps-5">
              <li>Safari'nin altındaki <Share className="inline w-4 h-4" /> <b>Paylaş</b> düğmesine dokunun.</li>
              <li><PlusSquare className="inline w-4 h-4" /> <b>Ana Ekrana Ekle</b>'yi seçin ve <b>Ekle</b>'ye dokunun.</li>
            </ol>
          ) : (
            <ol className="space-y-3 text-sm list-decimal ps-5">
              <li><b>Chrome / Edge (bilgisayar):</b> adres çubuğunun sağındaki <b>Yükle</b> simgesine ya da menüden <b>Uygulamayı yükle / Kısayol oluştur</b>'a tıklayın; "Pencere olarak aç" seçili olsun.</li>
              <li><b>Android:</b> Chrome menüsünden (⋮) <b>Ana ekrana ekle</b>'yi seçin.</li>
              <li><b>Diğer tarayıcılar:</b> bu sayfayı yer imlerine ekleyin veya adres çubuğundaki kilidi masaüstüne sürükleyin.</li>
            </ol>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
